import React from "react";
import "./LoaderOverlap.scss";

const LoaderOverlap = () => {
  return (
    <div className="loaderOverlay">
      <div class="loader"></div>
    </div>
  );
};

export default LoaderOverlap;
